module.exports = __webpack_public_path__ + "assets/img/x1.d5e99fac.png";